<style>
	.modal-mask .modal-body{
        max-height:75vh;
        overflow-y:auto;
	}
</style>
<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <button v-if="defaultLocation==null" class="btn btn-infbtn btn-xxs mb-2 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="getCurrentPosition">
                            <i class="fa fa-map-marker-alt font-10 ml-2"></i>
                            موقعیت فعلی
                        </button>
                        <!--<button v-if="defaultLocation!=null" @click="openInGoogleMap" class="btn btn-infbtn btn-xxs mb-2 btn-full bg-green2-dark rounded-sm font-900 w-100">
            <i class="fa fa-map-marker-alt font-10 ml-2"></i>
            نمایش در نقشه
        </button>-->

                        <slot name="body">
                            <div class="mb-4">
                                <l-map ref="mymap" style="height:300px" :zoom="16" :center="mapLocationObject" v-if="mapLocationObject!=null">
                                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                    <l-marker :lat-lng="mapLocationObject"></l-marker>
                                </l-map>

                            </div>
                        </slot>



                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.presenceDate!==null}">تاریخ </span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="userPresenceModel.presenceDate" readonly />
                        </div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-file-alt color-magenta2-light"></i>
                            <span class="color-highlight input-style-1-active">نوع :</span>
                            <select class="form-control" type="text" v-model="userPresenceModel.userPresenceTypeId" @change="setUserPresenceTitle">
                                <option value=0>ثبت موقعیت</option>
                                <option value=1>ورود</option>
                                <option value=2>خروج</option>
                            </select>
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-check color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.title!==null}">عنوان</span>
                            <input class="form-control" type="text" v-model="userPresenceModel.title">
                        </div>

                        <div class="card mx-0 mb-3">
                            <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                                <button data-toggle="collapse" data-target="#collapse-UserPresenceDescription">
                                    <i class="fa fa-edit mt-2"></i>
                                    <span>توضیحات</span>
                                    <i class="fa fa-angle-down"></i>
                                </button>
                            </div>

                            <div class="collapse collapse-reminderCalendars" id="collapse-UserPresenceDescription">
                                <textarea v-model="userPresenceModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>

                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="mb-3" v-if="WaitUserPresenceCaption">
                            <div></div>
                            <div class="text-center">
                                <i class="fa fa-sync fa-spin color-red2-dark ml-2"></i>
                                لطفا منتظر بمانید...
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button :disabled="WaitUserPresenceCaption!=false" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveUserPresenceLocation">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button :disabled="WaitUserPresenceCaption!=false" class="btn btn-xxs rounded-s bg-red1-light" id="btnUserPresenceClose" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>
    import { ref, onMounted } from 'vue';
    import "leaflet/dist/leaflet.css"
    import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
    import { Geolocation } from "@capacitor/geolocation";
    import { latLng } from "leaflet";
    import { Device } from '@capacitor/device';
    import { Icon } from 'leaflet';
    import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch'
    // import LGeosearch from "vue2-leaflet-geosearch";
    import "leaflet-geosearch/dist/geosearch.css";


    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });


    export default {
        setup() {
            const mymap = ref(null);
            return {
                mymap
            }
        },
        components: {
            LMap,
            LMarker,
            LTileLayer
        },
        props: ['defaultLocation', 'defaultAddress'],
        data() {
            return {
                mapLocationObject: null,
                mapLocation: null,
                position: null,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                Loading: false,
                errorMsg: null,
                readOnly: false,
                WaitUserPresenceCaption: false,
                address: null,
                logDeviceInfoForUserPresence: null,
                geoSearchOptions: {
                    provider: new OpenStreetMapProvider(),
                    showMarker: false,
                    autoClose: true
                },
                userPresenceModel: {
                    title: "ثبت موقعیت",
                    userPresenceId: 0,
                    userId: 0,
                    isAutomatic: false,
                    description: " ",
                    createDateTime: null,
                    attList: [],
                    presenceDate: null,
                    mapLocation: null,
                    countryTitle: null,
                    cityTitle: null,
                    address: null,
                    goBack: false,
                    ipAddress: null,
                    deviceInfo: " ",
                    userPresenceTypeId: 0
                },

            };
        },

        async created() {
            this.WaitUserPresenceCaption = true;
            if (this.defaultLocation == null) {
                await this.getCurrentPosition();
                document.addEventListener("deviceready", () => {
                    this.checkLocation();
                });

            }
            else {
                var m = this.defaultLocation.split(',');
                this.mapLocation = this.defaultLocation;
                this.mapLocationObject = latLng(m[0], m[1]);
            }
            this.WaitUserPresenceCaption = false;
            this.getUserPresenceServerDateTime();
        },


        watch: {
            mapLocationObject: {
                deep: true,
                async handler(value) {
                    this.address = await this.getAddress();
                    console.log(this.address);
                }
            }
        },

        methods: {
            setUserPresenceTitle() {
                if (this.userPresenceModel.userPresenceTypeId == 1) {
                    this.userPresenceModel.title = "ورود";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 2) {
                    this.userPresenceModel.title = "خروج";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 0) {
                    this.userPresenceModel.title = "ثبت موقعیت";
                }
                else {
                    this.userPresenceModel.title = "";
                }
            },
            async getAddress() {
                //this.loading = true;
                this.WaitUserPresenceCaption = true;
                let address = "Unresolved address";
                try {
                    const { lat, lng } = this.mapLocationObject;
                    const result = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa-IR`
                    );
                    if (result.status === 200) {
                        const body = await result.json();
                        address = body.display_name;
                    }
                    this.WaitUserPresenceCaption = false;
                } catch (e) {
                    console.error("Reverse Geocode Error->", e);
                    this.WaitUserPresenceCaption = false;
                }
                //this.loading = false;
                return address;
            },
            async getCurrentPosition() {
                this.WaitUserPresenceCaption = true;
                try {
                    const coordinates = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: true
                    });
                    this.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                    this.userPresenceModel.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                    this.mapLocationObject = latLng(coordinates.coords.latitude, coordinates.coords.longitude);
                    this.userPresenceModel.address = await this.getAddress();
                    this.WaitUserPresenceCaption = false;
                    await this.GetDeficeInfo(this.userPresenceModel.deviceInfo);
                    
                }
                catch (ex) {
                    console.log(ex);
                    this.showErrorMessage("خطا در دریافت موقعیت مکانی. لطفا از روشن بودن Location دستگاه خود مطمئن شوید و مجددا تلاش کنید.");
                    this.WaitUserPresenceCaption = false;
                    this.$emit('close');
                }

            },
            getUserPresenceServerDateTime() {
                this.WaitUserPresenceCaption = true;
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {

                        this.userPresenceModel.presenceDate = data.data.split("_")[0];
                        this.userPresenceModel.createDateTime = data.data.replace("_", " ");
                        this.WaitUserPresenceCaption = false;
                    });

            },
            checkLocation() {
                window.plugins.locationAccuracy.canRequest(function (canRequest) {
                    if (canRequest) {
                        window.plugins.locationAccuracy.request(function (success) {
                            console.log("Successfully requested accuracy: " + success.message);
                        }, function (error) {
                            console.error("Accuracy request failed: error code=" + error.code + "; error message=" + error.message);
                            if (error.code !== window.plugins.locationAccuracy.ERROR_USER_DISAGREED) {
                                if (window.confirm("Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?")) {
                                    window.plugins.diagnostic.switchToLocationSettings();
                                }
                            }
                        }, window.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
                    } else {
                        // request location permission and try again
                    }
                });
            },
            async GetDeficeInfo() {
                this.WaitUserPresenceCaption = true;
                this.logDeviceInfoForUserPresence = await Device.getInfo();
                this.userPresenceModel.deviceInfo = this.logDeviceInfoForUserPresence.model + " " + this.logDeviceInfoForUserPresence.platform + " " + this.logDeviceInfoForUserPresence.operatingSystem + " " + this.logDeviceInfoForUserPresence.osVersion + " " + this.logDeviceInfoForUserPresence.webViewVersion;
                this.WaitUserPresenceCaption = false;
            },
            async SaveUserPresenceLocation() {
                this.WaitUserPresenceCaption = true;
                this.$store.dispatch("CreateUserPresence", this.userPresenceModel).then(x => {
                    this.$emit('close');
                    this.WaitUserPresenceCaption = false;
                });
            },
        },

    };
</script>
<style>
    .modal-mask {
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        line-height: 1;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(2);
            transform: scale(2);
        }
</style>
